export const PURCHASE_LINK = 'https://payments.vantapro.shop/cart/4505...'

export const scrollToPrice = (e?: React.MouseEvent) => {
  e?.preventDefault()
  const priceSection = document.getElementById('precio')
  if (priceSection) {
    priceSection.scrollIntoView({ behavior: 'smooth' })
  }
}

export const IMAGES = {
  main: 'https://cdn.magicpatterns.com/uploads/us7UwK414CppBakT4U7GMo/7249dd85-7925-45b7-b138-845bb31ec175.png',
  bono1:
    'https://cdn.magicpatterns.com/uploads/jK575HJxYtHfkZbSuiaXLC/Diseno_sin_titulo_(15).png',
  bono2:
    'https://cdn.magicpatterns.com/uploads/aVSsgh68JZa1xUPS6Fk3Zp/Diseno_sin_titulo_(13).png',
  bono3:
    'https://cdn.magicpatterns.com/uploads/1go5dhhXc1yPa79UMJsG78/Diseno_sin_titulo_(14).png',
}
